// extracted by mini-css-extract-plugin
export default {"mainDiv":"carrent_mainDiv__kuxoT","Hotelab":"carrent_Hotelab__xEEG8","Flightabs":"carrent_Flightabs__xFjkO"};